
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerEditor()
    export class PsPanelGroupButtonEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PsPanelGroupButtonRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PsPanelGroupButtonRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
